import React from "react";
import { Button } from "react-bootstrap";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiCol, UiRowContainer, UiSingleRow } from "../../../components/grid-container/GridContainer";
import progressImage from '../../../../../styles/img/knowledge-progress.jpg';
import volvoLogo from '../../../../../styles/img/volvo-logo-round.png';
import { UiProgramCard } from "../../../components/common/UiProgramCard";
import programImage from '../../../../../styles/img/knowledge-progress.jpg';
import ProOne from "../../../../../styles/img/p-01.png";
import ProTwo from "../../../../../styles/img/p-02.png";
import ProThree from "../../../../../styles/img/p-03.png";
import ProFour from "../../../../../styles/img/p-04.png";
import ProFive from "../../../../../styles/img/p-05.png";
import ProSix from "../../../../../styles/img/p-06.png";
import { useNavigate } from "react-router-dom";


export const KnowledgeLatestPrograms = () => {
    let navigate = useNavigate(); 
    const browseAllProgramme = () =>{ 
        let path = `../../ui/all-quizzers`; 
        navigate(path, { replace: true });
    }
    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid">
                    <UiCol lg="12">
                        <UiContentCol>
                            <div className="sb-knw-latest-sec">
                                <div className="sb-knw-latest-sec__card-header">
                                    <UiCardTitle title="Latest Programmes" />
                                    <Button onClick={browseAllProgramme}>Browse All Programmes</Button>
                                </div>
                            </div>

                            <UiSingleRow>
                                <UiCol lg="6">
                                    <UiProgramCard
                                        title="Maximise Accessories"
                                        image={ProOne}
                                        labelType="featured"
                                    />
                                </UiCol>

                                <UiCol lg="6">
                                    <UiProgramCard
                                        title="New Aygo features by grade"
                                        image={ProTwo}
                                        labelType="new"
                                    />
                                </UiCol>

                                <UiCol lg="6">
                                    <UiProgramCard
                                        title="TFS Making the right choice"
                                        image={ProThree}
                                        labelType="new"
                                    />
                                </UiCol>

                                <UiCol lg="6">
                                    <UiProgramCard
                                        title="Introducing the All New bZ4X"
                                        image={ProFour}
                                        labelType="new"
                                    />
                                </UiCol>

                                <UiCol lg="6">
                                    <UiProgramCard
                                        title="Toyota C-HR Prologue Concept"
                                        image={ProFive}
                                        labelType="new"
                                    />
                                </UiCol>

                                <UiCol lg="6">
                                    <UiProgramCard
                                        title="Perform with Genuine Parts"
                                        image={ProSix}
                                        labelType="new"
                                    />
                                </UiCol>
                            </UiSingleRow>
                        </UiContentCol>
                    </UiCol>
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}